import { VisuallyHidden } from '@chakra-ui/react';
import { GET_STATIC_CONTENT, LEISURE_BRANDS, SITE_LEISURE } from '@whitbread-eos/api';
import { Alert, Notification } from '@whitbread-eos/atoms';
import { useCustomLocale, useQueryRequest } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FooterComponent = dynamic(() => import('./Footer.component'), {
  ssr: false
});
export default function Footer(_ref) {
  var _data$footer, _data$footer3, _data$footer4;
  var isPremierInn = _ref.isPremierInn,
    _ref$site = _ref.site,
    site = _ref$site === void 0 ? SITE_LEISURE : _ref$site;
  var _ref2 = useRouter() || {
      query: {}
    },
    query = _ref2.query;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var baseDataTestId = 'Footer';
  var brand = query !== null && query !== void 0 && query.BRAND ? String(query.BRAND).toLowerCase() : 'pi';
  var isLeisureBrand = useMemo(() => {
    return LEISURE_BRANDS.includes(brand);
  }, [brand]);
  var _useQueryRequest = useQueryRequest(['GetStaticContent', language, country], GET_STATIC_CONTENT, {
      country,
      language,
      site: site,
      businessBooker: false
    }),
    isLoading = _useQueryRequest.isLoading,
    isError = _useQueryRequest.isError,
    data = _useQueryRequest.data,
    error = _useQueryRequest.error;
  if (isLoading) {
    return _jsx(VisuallyHidden, {
      "data-testid": "loading-message",
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Notification, {
      status: "error",
      description: String(error),
      variant: "alert",
      maxW: "full",
      svg: _jsx(Alert, {})
    });
  }
  var footerData = [data === null || data === void 0 || (_data$footer = data.footer) === null || _data$footer === void 0 ? void 0 : _data$footer.tabs[0]];
  if (isPremierInn && isLeisureBrand) {
    var _data$footer2;
    footerData = data === null || data === void 0 || (_data$footer2 = data.footer) === null || _data$footer2 === void 0 ? void 0 : _data$footer2.tabs;
  }
  return _jsx(FooterComponent, {
    baseDataTestId: baseDataTestId,
    language: language || 'en',
    copyrightData: data === null || data === void 0 || (_data$footer3 = data.footer) === null || _data$footer3 === void 0 ? void 0 : _data$footer3.copyrightInfo,
    socialIcons: data === null || data === void 0 || (_data$footer4 = data.footer) === null || _data$footer4 === void 0 ? void 0 : _data$footer4.socialMediaIcons,
    tabsInfo: footerData,
    isPI: isPremierInn ? isLeisureBrand : false
  });
}